"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SignInMenu = exports.NavigationMethods = exports.HandleClose = exports.HandleClick = exports.GetSignInTestIdValues = void 0;
var NavigationMethods = _interopRequireWildcard(require("./Navigation"));
exports.NavigationMethods = NavigationMethods;
var NavigationStyles = _interopRequireWildcard(require("./NavigationStyles"));
var _CategoryMenuList = _interopRequireDefault(require("./CategoryMenuList"));
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Search = require("./../Search/Search");
var _classnames = _interopRequireDefault(require("classnames"));
var _debounce = require("../../utils/performance/debounce");
var _function = require("../../utils/type-checks/function");
var _object = require("../../utils/type-checks/object");
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  GetSignInTestIdValues = testId => {
    return {
      componentTestId: testId ? testId : undefined,
      buttonTestId: testId ? `${testId}_signin-button` : undefined,
      menuTestId: testId ? `${testId}_signin-popper` : undefined
    };
  },
  HandleClick = (value, existingValue, setter) => {
    let resolvedValue = null;
    if ((0, _function.isFunction)(setter)) {
      if (value !== existingValue) {
        resolvedValue = value;
      }
      setter(resolvedValue);
    }
    return resolvedValue;
  },
  HandleClose = setter => {
    let result = false;
    if ((0, _function.isFunction)(setter)) {
      setter(null);
      result = true;
    }
    return result;
  },
  SignInMenu = props => {
    if (!(0, _object.isObject)(window.PubSub)) {
      window.PubSub = require("pubsub-js");
    }
    const {
        autoOpen = false,
        customSignInStyles = {},
        customSignInPopperStyles = {},
        customTheme = {},
        defaultSignInAnchorId,
        fragmentId,
        testId
      } = props,
      theme = merge((0, _styles.useTheme)(), customTheme),
      signInId = "navigation__sign-in",
      [anchorEl, setAnchorEl] = (0, _react.useState)(null),
      defaultStyles = NavigationStyles.DefaultSignInStyles(theme),
      defaultPopperStyles = NavigationStyles.DefaultSignInPopperStyles(theme),
      styles = merge(defaultStyles, customSignInStyles),
      popperStyles = merge(defaultPopperStyles, customSignInPopperStyles),
      buttonClasses = (0, _classnames.default)({
        "navigation__sign-in-button": true,
        "navigation__sign-in-button--isSelected": Boolean(anchorEl)
      }),
      testIdMap = GetSignInTestIdValues(testId),
      handleClick = e => {
        const clickElement = (0, _string.isStringOfLength)(defaultSignInAnchorId) ? document.getElementById(defaultSignInAnchorId) : e.currentTarget;
        window.PubSub.publish("menu.close");
        NavigationMethods.HandleClick(clickElement, anchorEl, setAnchorEl);
      },
      handleClose = () => NavigationMethods.HandleClose(setAnchorEl);
    (0, _react.useEffect)(() => {
      const handleResize = (0, _debounce.debounce)(() => {
        if (anchorEl && window.innerWidth < theme.breakpoints.values.md) {
          handleClose();
        }
      }, 50);
      if (autoOpen && !anchorEl && (0, _string.isStringOfLength)(defaultSignInAnchorId) && document.getElementById(defaultSignInAnchorId)) {
        setAnchorEl(document.getElementById(defaultSignInAnchorId));
      } else {
        handleResize();
      }
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, [anchorEl, autoOpen, defaultSignInAnchorId, setAnchorEl, theme.breakpoints.values.md]);
    return /*#__PURE__*/_react.default.createElement(_material.ClickAwayListener, {
      onClickAway: handleClose
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      "data-testid": testIdMap.componentTestId,
      sx: styles
    }, /*#__PURE__*/_react.default.createElement(_material.Button, {
      "aria-label": "Click to open Sign In Menu",
      "aria-controls": Boolean(anchorEl) ? `${signInId}__target` : undefined,
      "aria-expanded": Boolean(anchorEl).toString(),
      "aria-haspopup": "true",
      className: buttonClasses,
      "data-testid": testIdMap.buttonTestId,
      id: signInId,
      onClick: handleClick,
      variant: "tertiary",
      value: "signin"
    }, "Sign In"), /*#__PURE__*/_react.default.createElement(_material.Popper, {
      anchorEl: anchorEl,
      className: "navigation__sign-in-menu",
      "data-testid": testIdMap.menuTestId,
      id: `${signInId}__target`,
      open: Boolean(anchorEl),
      onClose: handleClose,
      placement: "bottom-end",
      popperOptions: {
        strategy: "fixed"
      },
      sx: popperStyles
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      "aria-label": "Sign In Options",
      className: "navigation__sign-in-menu-wrapper",
      component: "nav"
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      className: "navigation__sign-in-menu-panel"
    }, /*#__PURE__*/_react.default.createElement("h2", null, "Sign In Options"), /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
      id: fragmentId
    }))))));
  };

/**
 * Desktop Navigation Controls
 *
 * @visibleName Desktop Navigation
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.SignInMenu = SignInMenu;
exports.HandleClose = HandleClose;
exports.HandleClick = HandleClick;
exports.GetSignInTestIdValues = GetSignInTestIdValues;
const Navigation = props => {
  if (!(0, _object.isObject)(window.PubSub)) {
    window.PubSub = require("pubsub-js");
  }
  const {
      bundledStyles = {},
      categoryArray,
      customTheme = {},
      defaultAnchorId,
      defaultSignInAnchorId,
      enableSearch,
      headerOffset = 0,
      searchId = "search_form",
      signInFragmentId,
      supplementalFragment,
      supplementalListStyles,
      supplementalPosition,
      supplementalTestId,
      testId,
      ...rest
    } = props,
    {
      customButtonStyles = {},
      customComponentStyles = {},
      customPopperStyles = {},
      customSignInStyles = {},
      customSignInPopperStyles = {}
    } = bundledStyles,
    [menuHeight, setMenuHeight] = (0, _react.useState)("0"),
    theme = merge((0, _styles.useTheme)(), customTheme),
    defaultComponentStyles = NavigationStyles.DefaultComponentStyles(theme),
    componentStyles = merge(defaultComponentStyles, customComponentStyles);
  (0, _react.useEffect)(() => {
    const setHeight = () => setMenuHeight(`${Math.round(window.innerHeight * 0.9) - headerOffset}px`);
    window.addEventListener("resize", setHeight);
    setHeight();
    return () => window.removeEventListener("resize", setHeight);
  }, [headerOffset]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    "aria-label": "Main Navigation",
    component: "nav",
    "data-testid": testId,
    id: "navigation",
    sx: componentStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, categoryArray.map((item, i) => /*#__PURE__*/_react.default.createElement(_material.Box, {
    key: `menu-button__list_${i}`
  }, item?.items && /*#__PURE__*/_react.default.createElement(_CategoryMenuList.default, _extends({
    customTheme: customTheme,
    customButtonStyles: customButtonStyles,
    customPopperStyles: merge({
      maxHeight: menuHeight
    }, customPopperStyles),
    defaultAnchorId: defaultAnchorId,
    items: item.items,
    ad: item.ad
  }, rest)), item?.fragments && /*#__PURE__*/_react.default.createElement(_CategoryMenuList.default, _extends({
    autoOpen: true,
    customButtonStyles: customButtonStyles,
    customPopperStyles: merge({
      maxHeight: menuHeight
    }, customPopperStyles),
    customTheme: customTheme,
    defaultAnchorId: defaultAnchorId,
    items: [item],
    ad: item.ad
  }, rest))))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "navigation__sign-in-section",
    sx: {
      alignItems: "center",
      display: "flex"
    }
  }, (0, _string.isStringOfLength)(supplementalFragment) && supplementalPosition === "right" && /*#__PURE__*/_react.default.createElement(_material.Box, {
    "aria-label": "Sitewide Header Links",
    component: "nav",
    "data-testid": supplementalTestId,
    sx: supplementalListStyles
  }, /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: supplementalFragment
  })), enableSearch && /*#__PURE__*/_react.default.createElement(_Search.SearchButton, {
    className: "Search--isNavigation",
    customTheme: customTheme,
    searchId: searchId
  }), (0, _string.isStringOfLength)(signInFragmentId) && /*#__PURE__*/_react.default.createElement(SignInMenu, {
    customSignInStyles: customSignInStyles,
    customSignInPopperStyles: merge({
      ".navigation__sign-in-menu-panel": {
        maxHeight: menuHeight
      }
    }, customSignInPopperStyles),
    customTheme: customTheme,
    defaultAnchorId: defaultAnchorId,
    defaultSignInAnchorId: defaultSignInAnchorId,
    id: "sign-in-menu",
    fragmentId: signInFragmentId
  })));
};

// Define propTypes;
Navigation.propTypes = {
  /** Collection of bundled style objects (Default Value: {}) */
  bundledStyles: _propTypes.default.shape({
    /** Custom styles object for menu button */
    customButtonStyles: _propTypes.default.object,
    /** Custom styles object for component */
    customComponentStyles: _propTypes.default.object,
    /** Custom styles for MegaNav Popper Menu Windows */
    customPopperStyles: _propTypes.default.object,
    /** Custom Styles for Sign In Menu Component */
    customSignInStyles: _propTypes.default.object,
    /** Custom Styles for Sign In Popper Menu Window */
    customSignInPopperStyles: _propTypes.default.object
  }),
  /** Category array for building menu items and children */
  categoryArray: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Visible Label of category link */
    label: _propTypes.default.string,
    /** Unique string used to manage internal state */
    value: _propTypes.default.string,
    /** Array of child items for display */
    items: _propTypes.default.arrayOf(_propTypes.default.shape({
      /** Visible Label of Child Link */
      label: _propTypes.default.string,
      /** Unique string used to manage internal state */
      value: _propTypes.default.string,
      /** Fragment ID of related menu panel */
      fragmentId: _propTypes.default.string
    }))
  })).isRequired,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Default Anchor ID for MegaNav popper windows */
  defaultAnchorId: _propTypes.default.string,
  /** Default Anchor ID for Sign In Navigation Menu */
  defaultSignInAnchorId: _propTypes.default.string,
  /** Enables/Disables Search Button Display */
  enableSearch: _propTypes.default.bool,
  /** Height of header for menu height computation (Default Value: 0) */
  headerOffset: _propTypes.default.number,
  /** String for Search Block ID */
  searchId: _propTypes.default.string,
  /** Fragment ID of Sign In Menu Links */
  signInFragmentId: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /** Fragment ID of supplimental navigation links */
  supplementalFragment: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /** Custom styles object for supplemental list */
  supplementalListStyles: _propTypes.default.object,
  /** Position of supplimental navigation */
  supplementalPosition: _propTypes.default.oneOf(["right", "top"]),
  /** @ignore */
  testId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool])
};
SignInMenu.propTypes = {
  autoOpen: _propTypes.default.bool,
  customSignInStyles: _propTypes.default.object,
  customSignInPopperStyles: _propTypes.default.object,
  customTheme: _propTypes.default.object,
  defaultSignInAnchorId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  fragmentId: _propTypes.default.string.isRequired,
  testId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool])
};

// Export component as default;
var _default = exports.default = Navigation;